import { useEffect } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const Liferay: any;

/**
 * Hook that will automatically extend the session within the defined interval as long as it's active.
 *
 * @param millis interval in milliseconds
 * @param active whether the hook is active. If it's not active, session won't be extended
 */
export function useLiferaySessionExtender(
  millis: number,
  active: boolean
): void {
  useEffect(() => {
    const extSession = () => {
      console.log('extend liferay session');
      Liferay.Session.extend();
    };
    let interval: NodeJS.Timer | undefined = undefined;
    if (active) {
      interval = setInterval(extSession, millis);
    }
    return () => {
      console.log('clear interval!!!', interval);
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [millis, active]);
}
